import { Component, OnInit, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { ErrorMessage } from 'ng-bootstrap-form-validation';
import { MainService } from '../../../../services';
import { Messaggio, Immobile, Orario, OrarioPrenotazione } from '../../../../models';
import { DatepickerOptions } from 'app/components/utilita/datepicker/datepicker.component';
import * as itLocale from 'date-fns/locale/it';
import { getYear, setDate, getDate } from 'date-fns';

@Component({
  selector: 'app-dialog-invia-messaggio-prenotazione',
  templateUrl: './dialog-invia-messaggio-prenotazione.component.html',
  styleUrls: ['./dialog-invia-messaggio-prenotazione.component.css']
})
export class DialogInviaMessaggioPrenotazione implements OnInit {
  errorObj: { error: boolean , errorMsg: string} = { error: false, errorMsg: ''};
  formGroup: FormGroup;
  messaggio: Messaggio;
  minDate: Date;
  loading: boolean = false;

  listOre: {value: number, label: string}[] 
      = [{value: undefined, label: 'Ora'}, {value: 6, label: '06'},
      {value: 7, label: '07'}, {value: 8, label: '08'},
      {value: 9, label: '09'}, {value: 10, label: '10'},
      {value: 11, label: '11'}, {value: 12, label: '12'},
      {value: 13, label: '13'}, {value: 14, label: '14'},
      {value: 15, label: '15'}, {value: 16, label: '16'},
      {value: 17, label: '17'}, {value: 18, label: '18'},
      {value: 19, label: '19'}, {value: 20, label: '20'},
      {value: 21, label: '21'}, {value: 22, label: '22'},
      {value: 23, label: '23'} ];
  
  listMinuti: {value: number, label: string}[] 
      = [{value: undefined, label: 'Min.'}, {value: 0, label: '00'},
      {value: 15, label: '15'}, {value: 30, label: '30'}, {value: 45, label: '45'}];

  orari: Orario[] = [new Orario, new Orario, new Orario];

  numOrari: number[] = [0];

  options: DatepickerOptions  = {
    locale: itLocale,
    minYear: getYear(new Date()) - 1,
    maxYear: getYear(new Date()) + 14,
    minDate: setDate(new Date(), getDate(new Date()) - 1)
  };

  constructor(public dialogRef: MatDialogRef<DialogInviaMessaggioPrenotazione>,
    private mainService: MainService,
    @Inject(MAT_DIALOG_DATA) public data: Immobile) 
  { 
    dialogRef.disableClose = true;
    this.messaggio = new Messaggio();
    this.messaggio.dataCreazione = new Date();
    this.messaggio.immobile = data;
    this.messaggio.oggetto = 'Prenotazione visita Immobile #Rif. ' 
      + data.riferimento.toLocaleString('it-IT', {minimumIntegerDigits: 6}).replace('.', '');
  }
 
  ngOnInit() {
    this.minDate = new Date();
    this.minDate.setTime(this.minDate.getTime() + (1000 * 60 * 60 * 24));
    this.formGroup = new FormGroup({
      oggetto: new FormControl('', []),
      fcDataOrario0: new FormControl('', [Validators.required]),
      fcMinAOrario0: new FormControl('', [Validators.required]),
      fcOraAOrario0: new FormControl('', [Validators.required]),
      fcMinDaOrario0: new FormControl('', [Validators.required]),
      fcOraDaOrario0: new FormControl('', [Validators.required]),
      fcDataOrario1: new FormControl('', []),
      fcMinAOrario1: new FormControl('', []),
      fcOraAOrario1: new FormControl('', []),
      fcMinDaOrario1: new FormControl('', []),
      fcOraDaOrario1: new FormControl('', []),
      fcDataOrario2: new FormControl('', []),
      fcMinAOrario2: new FormControl('', []),
      fcOraAOrario2: new FormControl('', []),
      fcMinDaOrario2: new FormControl('', []),
      fcOraDaOrario2: new FormControl('', [])
    });
  }

  addLine () {
    this.numOrari.push(this.numOrari.length);
  }

  removeLine () {
    this.numOrari.splice((this.numOrari.length-1),1)
  }

  

  invia() {
    this.loading = true;
    if (this.formGroup.valid) {
      this.errorObj = {error: false, errorMsg: ''};
      this.messaggio.listOrarioPrenotazione = new Array<OrarioPrenotazione>();

      let errore = false;
      for (let index of this.numOrari) {
        if(this.orari[index].data !== undefined) {
          
          if (Number(this.orari[index].oraDa) < Number(this.orari[index].oraA)) {

            let temp = new OrarioPrenotazione();
            temp.dataOraDa = new Date(this.orari[index].data);
            temp.dataOraDa.setHours(this.orari[index].oraDa);
            temp.dataOraDa.setMinutes(this.orari[index].minutiDa);
            temp.dataOraA = new Date(this.orari[index].data);
            temp.dataOraA.setHours(this.orari[index].oraA);
            temp.dataOraA.setMinutes(this.orari[index].minutiA);

            this.messaggio.listOrarioPrenotazione.push(temp);

          } else if (Number(this.orari[index].oraDa) === Number(this.orari[index].oraA) && 
            Number(this.orari[index].minutiDa) < Number(this.orari[index].minutiA)) 
          {
            let temp = new OrarioPrenotazione();
            temp.dataOraDa = new Date(this.orari[index].data);
            temp.dataOraDa.setHours(this.orari[index].oraDa);
            temp.dataOraDa.setMinutes(this.orari[index].minutiDa);
            temp.dataOraA = new Date(this.orari[index].data);
            temp.dataOraA.setHours(this.orari[index].oraA);
            temp.dataOraA.setMinutes(this.orari[index].minutiA);

            this.messaggio.listOrarioPrenotazione.push(temp);
          } 
            else 
          {
            errore = true;
          }
        } else {
          errore = true;
        }
      }
      if (errore == false) {
        this.mainService.tokenExpiredService.ifTokenNotExpired().subscribe(
          response => {
            if(response) {
              this.mainService.messaggioService.postPrenotazione(this.messaggio).subscribe(
                () => { 
                  this.dialogRef.close();
                  this.loading = false;
                  this.mainService.alertService.success('La sua richiesta è stata inoltrata!');
                },
                () => {
                  this.errorObj = {error: true, errorMsg: 'ERRORE: Il messaggio non è stato inviato!'};
                  this.loading = false;
                }
              );
            }
        });
      } else if (errore == true){
        this.errorObj = {error: true, errorMsg: 'ERRORE: Verificare l\'orario inserito!'};
        this.loading = false;
      }
    } else {
      this.errorObj = {error: true, errorMsg: 'ERRORE: Verificare l\'orario inserito!'};
      this.loading = false;
    }
  }

  required: ErrorMessage[] = [
    {
      error: 'required',
      format: (label, error) => ``
    }
  ];
}


// WEBPACK FOOTER //
// /home/david/vscode-workspace/TOP-casa-nel-web/frontend/src/app/components/utilita/dialogs/dialog-invia-messaggio-prenotazione/dialog-invia-messaggio-prenotazione.component.ts